<div class="error">
    <div class="icon-container">
        <mat-icon>check</mat-icon>
    </div>
    <span>{{ I18N.ERROR_CALLBACK_REQUEST | i18n | async }}</span>
</div>
